class PremiumFooter extends HTMLElement {
  connectedCallback() {
    this.media = window.matchMedia('(max-width: 599px)');
    this.updateMenus();
    this.media.addEventListener('change', this.updateMenus);
  }

  disconnectedCallback() {
    this.media?.removeEventListener('change', this.updateMenus);
  }

  updateMenus = () => {
    const open = !this.media.matches || this.dataset.mobileMenusOpen === 'true';
    this.querySelectorAll('details.pf__column').forEach((menu) => { menu.open = open; });
  };
}

if (!customElements.get('premium-footer')) {
  customElements.define('premium-footer', PremiumFooter);
}
